/* Copyright (c) 2022-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { Text } from "@nordcloud/gnui";
import { ExternalLink } from "~/components";

type Props = {
  uri: string;
};

export function AwsFormCFStackInfo({ uri }: Props) {
  return (
    <Text>
      Download and deploy&nbsp;
      <ExternalLink href={uri}>CloudFormation stack</ExternalLink>
      &nbsp;on your organization&apos;s account.
    </Text>
  );
}
